export default function nonEmpty<T>(item: T | null | undefined): item is T {
  return Boolean(item);
}

export function nonEmptyId<T extends { id?: string | null }>(
  item: T | undefined | null,
): item is T & { id: string } {
  return Boolean(item?.id);
}
